import { render, staticRenderFns } from "./ReceiptInfo.vue?vue&type=template&id=37cf09ba&scoped=true"
import script from "./ReceiptInfo.vue?vue&type=script&lang=js"
export * from "./ReceiptInfo.vue?vue&type=script&lang=js"
import style0 from "./ReceiptInfo.vue?vue&type=style&index=0&id=37cf09ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37cf09ba",
  null
  
)

export default component.exports